import { useEffect } from 'react'

// HubSpot Embed Code — portal 367443. Intentionally scoped to this hook so
// tracking only fires on the checkout confirmation page; loading it globally
// would pollute marketing-site analytics.
const HUBSPOT_SCRIPT_ID = 'hs-script-loader'
const HUBSPOT_SCRIPT_SRC = 'https://js.hs-scripts.com/367443.js'

declare global {
  interface Window {
    _hsq?: unknown[]
    hbspt?: unknown
  }
}

export function useHubSpotSnippet() {
  useEffect(() => {
    // Only append if nothing (including GTM or another plugin) has already
    // injected the loader. Cleanup runs regardless, so that if something else
    // injected it before we mounted, we still tear it down when we unmount —
    // otherwise HubSpot would keep tracking the rest of the SPA, defeating
    // the whole point of scoping it to this page.
    if (!document.getElementById(HUBSPOT_SCRIPT_ID)) {
      const script = document.createElement('script')
      script.id = HUBSPOT_SCRIPT_ID
      script.type = 'text/javascript'
      script.async = true
      script.defer = true
      script.src = HUBSPOT_SCRIPT_SRC
      document.body.appendChild(script)
    }

    return () => {
      // Best-effort cleanup: remove the loader tag and clear the globals we
      // know about. HubSpot may have injected additional <script>, <iframe>,
      // or <style> nodes during initialization that we don't track — those
      // stay in the DOM but are dormant once _hsq/hbspt are gone.
      document.getElementById(HUBSPOT_SCRIPT_ID)?.remove()
      // HubSpot's loader declares these with `var`, making them non-configurable;
      // `delete` on them throws in strict mode, so overwrite instead.
      window._hsq = undefined
      window.hbspt = undefined
    }
  }, [])
}
